import router from "@/router/router";

/**
 * 路由攔截
 */
router.beforeEach((to, from, next) => {
    // 檢查 URL 查詢參數中的 mode 值
    const mode = to.query.mode;
    if(mode === '1') {
        document.title = '台北榮耀堂';
    } 
    return next()
})

router.afterEach(() => {
});

export default router;
